/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React, { useMemo } from "react";
import { DIALOGOPENFOR } from "../../../../globals/globals";
import AddRegion from "./AddRegion";
import { useAddEditRegion } from "./hooks";
import { IGeoRegion } from "../../../../store/api/admin/types";
import RegionInfo from "./RegionInfo";
import AssociationNavigation from "../../../../components/Shared/Association/AssociationNavigation";
import { Ioptions } from "../../../../components/Shared/Filter/types";
import { useSelector } from "react-redux";
import { selectedGeoRegionSelector } from "../../../../store/filters/Nodes/selectors";

const Regions: React.FC = () => {
  const {
    permittedGeoRegions,
    selectedRegion,
    setSelectedRegion,
    saveButtonEnabled,
    setSaveButtonEnabled,
    openModal,
    errMsg,
    onBlurHandler,
    deleteClickHandler,

    deleteRegionByItem,

    handleNameChange,
    handleSave,
    geoRegions
  } = useAddEditRegion();

  const selectedGeoRegion = useSelector(selectedGeoRegionSelector);

  const navItems: Ioptions[] = useMemo(
    () => (permittedGeoRegions || []).map((region: IGeoRegion) => {
      const canDelete = selectedGeoRegion !== region?.name && (region?.siteGroups?.length || 0) === 0;
      return { text: region.name, value: region.objectKey, canDelete };
    }),
    [permittedGeoRegions, selectedGeoRegion]
  );

  const selectedItem = useMemo(
    () => navItems.find((item) => item.value === selectedRegion.objectKey),
    [navItems, selectedRegion.objectKey]
  );

  const handleConfirmDeleteRegion = () => {
    if (selectedItem) {
      void deleteRegionByItem(selectedItem);
    }
  };

  const handleNavItemClick = (item: Ioptions) => {
    const region = permittedGeoRegions?.find((r: IGeoRegion) => r.objectKey === item.value);
    if (region) {
      setSelectedRegion(region);
    }
  };

 const MAX_REGIONS = 1;
  return (
    <div className="flex flex-row flex-nowrap gap-6" style={{ color: "var(--foreground)" }}>
      {openModal === DIALOGOPENFOR.ADDREGION && (
        <AddRegion
          selectedRegion={selectedRegion}
          setSelectedRegion={setSelectedRegion}
          onNameChange={handleNameChange}
          onNameBlur={onBlurHandler}
          onSubmit={handleSave}
          saveButtonEnabled={saveButtonEnabled}
          setSaveButtonEnabled={setSaveButtonEnabled}
          errMsg={errMsg}
        />
      )}
      <AssociationNavigation
        searchPlaceholder={"Search regions..."}
        navHeaderName={"Regions"}
        selectedItemIndex={selectedItem}
        isManagePermission={true}
        navItems={navItems}
        ShowSearchFilterOnRecordsCount={MAX_REGIONS}
        confirmDeleteDialogOpener={DIALOGOPENFOR.DELETEREGION}
        deleteConfirmationMessage={"Are you sure you want to delete region"}
        addDialogOpener={DIALOGOPENFOR.ADDREGION}
        handleNavItemClick={handleNavItemClick}
        deleteNavItemHandler={deleteRegionByItem}
        isCountBadgeVisible={false}
        maxHeight={"calc(100vh - 15rem)"}
        isDeleteIconVisible={false}
      />
      <div className="flex-1">
        <RegionInfo
          selectedRegion={selectedRegion}
          onNameChange={handleNameChange}
          onNameBlur={onBlurHandler}
          deleteClickHandler={deleteClickHandler}
          confirmDeleteHandler={handleConfirmDeleteRegion}
          submitHandler={handleSave}
          saveButtonEnabled={saveButtonEnabled}
          errMsg={errMsg}
          geoRegions={geoRegions}
        />
      </div>
    </div>
  );
};

export default Regions;
